// Etapa 6: service worker (solo producción y contexto seguro). Guarda SOLO los archivos de la app
// para que un F5 o reabrir el navegador sin conexión cargue el sistema. Nunca guarda la API.
import { useConexion } from '@/stores';

const UNA_HORA = 3600000;

export function registrarServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator) || !window.isSecureContext) return; // HTTPS o localhost

  // D5: interruptor de emergencia. Desregistra y borra las cachés de la app en este equipo.
  if (process.env.VUE_APP_SERVICE_WORKER === 'off') {
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()));
    if (window.caches) caches.keys().then((ks) => ks.filter((k) => k.startsWith('zapi-pos')).forEach((k) => caches.delete(k)));
    return;
  }

  // Después de la carga, para no competir con la primera pintura
  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`, { updateViaCache: 'none' });
      vigilarActualizacion(reg);
      // Las pestañas del POS pasan días abiertas: buscar versión nueva cada hora y al volver a la pestaña
      setInterval(() => buscarVersionNueva(reg), UNA_HORA);
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') buscarVersionNueva(reg); });
    } catch (e) {
      console.warn('No se pudo registrar el service worker:', e); // la app sigue funcionando como hoy
    }
  });
}

function buscarVersionNueva(reg) {
  if (useConexion().modoOffline) return;
  reg.update().catch(() => {}); // sin red o servidor caído: se reintenta en la próxima
}

// (6.4) Avisa cuando una versión nueva queda instalada y esperando
function vigilarActualizacion(reg) {
  // Sin controlador al cargar = primera instalación: con clientsClaim también dispara controllerchange, y ahí no se recarga
  const habiaControlador = !!navigator.serviceWorker.controller;
  const avisar = () => { useConexion().versionNueva = true; };
  if (reg.waiting && navigator.serviceWorker.controller) avisar();
  reg.addEventListener('updatefound', () => {
    const nuevo = reg.installing;
    if (!nuevo) return;
    nuevo.addEventListener('statechange', () => {
      // «installed» con un controlador previo = actualización (no la primera instalación)
      if (nuevo.state === 'installed' && navigator.serviceWorker.controller) avisar();
    });
  });
  // Cuando la versión nueva toma el control, se recarga UNA vez para usar sus archivos
  let recargando = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!habiaControlador || recargando) return;
    recargando = true;
    window.location.reload();
  });
}

// Botón «Actualizar» de la franja, o automático en la pantalla de login (D3)
export async function aplicarVersionNueva() {
  if (!('serviceWorker' in navigator)) return;
  const reg = await navigator.serviceWorker.getRegistration();
  if (reg && reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
}
